import { ReadKnowledgeBasesApiResponse } from 'apis/knoledgeBases/types/knowledgeBasesApi.types';

/**
 * Returns the transformed response to match our ApiResponse format.
 *
 * @param response The raw response from the KB endpoint.
 */
export function transformKnowledgeBasesResponse(
  response: any,
): ReadKnowledgeBasesApiResponse {
  return {
    data: {
      knowledgeBases: response,
    },
    meta: {},
  };
}

/**
 * Returns the transformed response to match our ApiResponse format.
 *
 * @param response The raw response from the KB endpoint.
 */
export function transformKnowledgeBaseResponse(response: any): any {
  return {
    data: response,
    meta: {},
  };
}
